const muiXTelemetryEvents = {
  licenseVerification: (context, payload) => ({
    eventName: 'licenseVerification',
    payload,
    context
  })
};
export default muiXTelemetryEvents;